import { createFeatureSelector, createSelector } from '@ngrx/store';

import { CustomCategoryGrid } from '../models/custom-category.models';

const getCustomCategoryState = createFeatureSelector<CustomCategoryGrid>('custom-category-grid');

export const getCustomCategory = createSelector(
    getCustomCategoryState,
    (state: CustomCategoryGrid) => state?.gridCustomCategory
);

export const getCustomCategoryPageAllIds = createSelector(getCustomCategoryState, (state: CustomCategoryGrid) =>
    state?.gridCustomCategory?.idsFiltered);

export const getCustomCategoryPageProductIds = createSelector(getCustomCategoryState, (state: CustomCategoryGrid) =>
    state?.gridCustomCategory?.pageProductIds);

export const gridCustomCategoryFullyLoaded = createSelector(getCustomCategoryState, (state: CustomCategoryGrid) =>
    state?.gridCustomCategory?.productsFullyLoaded);

export const getCustomCategoryPageIdsFiltered = createSelector(getCustomCategoryState, (state: CustomCategoryGrid) =>
    state?.gridCustomCategory?.idsFiltered);

export const getPageCustomCategoryProductIdsLength = createSelector(getCustomCategoryState, (state: CustomCategoryGrid) =>
    state?.gridCustomCategory?.pageProductIds?.length);

// PUBLIC API
export const getCustomCategoryTotalQuantityProducts = createSelector(
    getCustomCategoryState,
    (state: CustomCategoryGrid) => state?.totalQuantityProducts
);

export const getCustomCategoryGridType = createSelector(
    getCustomCategoryState,
    (state: CustomCategoryGrid) => state?.gridType
);

export const getCustomCategoryCategoryId = createSelector(
    getCustomCategoryState,
    (state: CustomCategoryGrid) => state?.categoryId
);

export const getCustomCategoryInfo = createSelector(getCustomCategoryState, (state: CustomCategoryGrid) => {
    return {
        gridType: state?.gridType,
        gridgridCustomCategory: state?.gridCustomCategory,
    };
});
